import Widget from '@Components/Shared/Widgets/Widget';
import translator from '@Components/Utilities/Translator';

const WidgetDisplay = (props) => {
    return (
        <div className='widget__container'>
            <Widget
                showWidget={props.ShowLenderWidget}
                imageSource={props.LenderImageURL}
                url={props.LenderWidgetURL}
                label={translator.translate('sandhills.crm.dscrm.financing')}
                className={props.WidgetClass}
                registrationPage
            />
            <Widget
                showWidget={props.ShowHaulerWidget}
                imageSource={props.HaulerImageURL}
                url={props.HaulerWidgetURL}
                label={translator.translate('sandhills.crm.dscrm.shipping')}
                className={props.WidgetClass}
                registrationPage
            />
            <Widget
                showWidget={props.ShowInsuranceWidget}
                imageSource={props.InsuranceImageURL}
                url={props.InsuranceWidgetURL}
                label={translator.translate('sandhills.crm.dscrm.insurance')}
                className={props.WidgetClass}
                registrationPage
            />
        </div>
    );
};

export default WidgetDisplay;